import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExplanationEn } from "../../explanations/ExplanationEn";
import { ExplanationEs } from "../../explanations/ExplanationEs";
import { ExplanationIt } from "../../explanations/ExplanationIt";
import { ExplanationPyramidEn } from "../../explanations/ExplanationPyramidEn";
import { ExplanationPyramidEs } from "../../explanations/ExplanationPyramidEs";
import { ExplanationPyramidIt } from "../../explanations/ExplanationPyramidIt";

export const Accordion = () => {
  let { lang } = useParams();
  const { t } = useTranslation();

  let LanguageExplanationComponent;
  switch (lang) {
    case 'en':
      LanguageExplanationComponent = ExplanationEn;
      break;
    case 'es':
      LanguageExplanationComponent = ExplanationEs;
      break;
    case 'it':
      LanguageExplanationComponent = ExplanationIt;
      break;
    default:
      LanguageExplanationComponent = ExplanationEn;
  }

  let PyramidComponent;
  switch (lang) {
    case 'en':
      PyramidComponent = ExplanationPyramidEn;
      break;
    case 'es':
      PyramidComponent = ExplanationPyramidEs;
      break;
    case 'it':
      PyramidComponent = ExplanationPyramidIt;
      break;
    default:
      PyramidComponent = ExplanationPyramidEn;
  }

  return (
    <div className="max-w-4xl mx-auto p-2 mx-auto bg-white rounded-2xl mt-8">
      <details className="mb-4">
        <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4">
          {t('ex_01')}
        </summary>
        <div className="mt-2 px-4 py-2 bg-gray-100 rounded-md">
          <LanguageExplanationComponent />
        </div>
      </details>
      <details className="mb-4">
        <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4">
          {t('ex_02')}
        </summary>
        <div className="mt-2 px-4 py-2 bg-gray-100 rounded-md">
          <PyramidComponent />
        </div>
      </details>
    </div>

  );
};
